const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Edit Workflows Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 */
app.controller('editWorkflow', ['Application', 'Authorization', 'Analyze', '$scope', '$translate', 'Workflows', 'AccessHelper', function(Application, Authorization, Analyze, $scope, $translate, Workflows, AccessHelper) {
    var self = this;
    self.flags = Application.features.flags();
    self.user = Authorization.getAuthToken().user;
    self.editSaved = true;
    self.denied = false;
    var routeParameters = Application.navigation.getRouteParameters();
    self.newFlow = routeParameters.id === 'new' || !routeParameters.id;
    self.activetab = 'if';
    self.helptext = '';
    self.helptextsection = '';
    self.shareRestrictions = ['assessment'];
    self.translations = {};

    self.allowance = {
      workflows: AccessHelper.isAllowed(['admin', 'workflows'], null, ['admin', 'creator']),
    };

    if (!self.allowance.workflows) {
      Application.navigation.goTo('/explore');
      return;
    }

    var locationChange = $scope.$on('$locationChangeStart', function(event) {
      if (self.editSaved) {
        // Allow the route change to progress
        self.denied = true;
        return;
      }

      // Halt the route change and question the action
      self.navigationPath = {};
      self.navigationPath.targetPath = Application.navigation.getPath();
      self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
      self.navigationPath.targetHash = Application.navigation.getHash();
      event.preventDefault();
      self.showDeparture = true;
      self.onLocationChange = function() {
        locationChange();
      };
    });

    self.validation = {
      showDelete: false,
      segmentationTypes: ['location', 'department', 'team', 'org_level', 'grade', 'group', 'group_location', 'group_department', 'group_team', 'group_org_level', 'group_grade'],
      numberRequiredTypes: ['hired_within-custom-days', 'hired_exactly-custom-days-ago'],
      conditionals: ['location', 'department', 'team', 'org_level', 'grade', 'group', 'location_added', 'department_added', 'team_added', 'org_level_added', 'grade_added', 'group_added', 'hired_within-30-days', 'hired_within-custom-days', 'hired_exactly-60-days-ago', 'hired_exactly-90-days-ago', 'hired_exactly-custom-days-ago', 'all_teams', 'all_groups', 'all_teams_added', 'all_groups_added', 'group_location', 'group_department', 'group_team', 'group_org_level', 'group_grade', 'users_and_groups', 'groups_fields_all'],
      fail: function(field) {
        var errorDirectory = {
          type: self.translations['edit.workflows.errors_type'],
          object_type: self.translations['edit.workflows.errors_object_type'],
          object_instance: self.translations['edit.workflows.errors_object_instance'],
          object_number: self.translations['edit.workflows.errors_object_number'],
          conditional_object_type: self.translations['edit.workflows.errors_conditional_object_type'],
          'object_instance-location': self.translations['edit.workflows.errors_addLocation'],
          'object_instance-department': self.translations['edit.workflows.errors_addDepartment'],
          'object_instance-team': self.translations['edit.workflows.errors_addTeam'],
          'object_instance-org_level': self.translations['edit.workflows.errors_addOrgLevel'],
          'object_instance-grade': self.translations['edit.workflows.errors_addGrade'],
          'object_number-hired_within-custom-days': self.translations['edit.workflows.errors_addConditionalCustomDays'],
          'object_number-hired_exactly-custom-days-ago': self.translations['edit.workflows.errors_addConditionalCustomDays'],
          noresponse: self.translations['edit.workflows.errors_noresponse'],
          responseitem: self.translations['edit.workflows.errors_responseitem'],
          name: self.translations['edit.workflows.errors_name'],
          noemail: self.translations['edit.workflows.errors_noemail'],
          emailsubject: self.translations['edit.workflows.errors_emailsubject'],
          emailbody: self.translations['edit.workflows.errors_emailbody'],
          overdue_messages: self.translations['assignContent.overdue_due_date']
        };
        Application.messaging.addMessage({type: 'error', text: errorDirectory[field], duration: 7});
      },
      fieldCheck: function(fields) {
        for (var i = 0; i < fields.length; i++) {
          if (!self.workflow[fields[i]]) {
            this.fail(fields[i]);
            return false;
          }
        }
        return true;
      },
      stepCheck: function(level) {
        var fields = [];
        switch (level) {
          case 'if':
            fields.push('type');
            if (self.workflow.type === 'completed_content') {
              fields.push('object_type');
              fields.push('object_instance');
            }
            if (self.workflow.type === 'hired_custom') {
              fields.push('object_number');
            }
            break;
          case 'and':
            if (!self.workflow.conditionals || !self.workflow.conditionals.length) {
              break;
            }
            for (var i = 0; i < self.workflow.conditionals.length; i++) {
              if (!self.workflow.conditionals[i].object_type || this.conditionals.indexOf(self.workflow.conditionals[i].object_type) === -1) {
                this.fail('conditional_object_type');
                return false;
              }
              if (self.validation.segmentationTypes.indexOf(self.workflow.conditionals[i].object_type) !== -1) {
                if (!self.workflow.conditionals[i].object_instance) {
                  this.fail('object_instance-' + self.workflow.conditionals[i].object_type);
                  return false;
                }
              }
              if (self.validation.numberRequiredTypes.indexOf(self.workflow.conditionals[i].object_type) !== -1) {
                if (!self.workflow.conditionals[i].object_number) {
                  this.fail('object_number-' + self.workflow.conditionals[i].object_type);
                  return false;
                }
              }
            }
            break;
          case 'then':
            if (!self.workflow.responses || !self.workflow.responses.length) {
              this.fail('noresponse');
              return false;
            }
            for (var i = 0; i < self.workflow.responses.length; i++) {
              var item = self.workflow.responses[i];
              if (!item.type || !item.object_type || !item.object_instance) {
                this.fail('responseitem');
                return false;
              }
            }
            break;
          case 'title':
            fields.push('name');
            break;
          case 'notifications':
            // check if assignment response
            if (self.hasAssignment) {
              if (self.assignments.settings.non_reminder_messages && self.assignments.settings.non_reminder_messages.length) {
                // Making an assumption here that the non_reminder_message is on creation
                break;
              }
            }

            if (!self.workflow.response_options || !self.workflow.response_options.length) {
              this.fail('noemail');
              return false;
            }
            var checkBody = false;
            var checkSubject = false;
            for (var i = 0; i < self.workflow.response_options.length; i++) {
              if (self.workflow.response_options[i].name === 'email-body' && self.workflow.response_options[i].value) {
                checkBody = true;
              }
              if (self.workflow.response_options[i].name === 'email-subject' && self.workflow.response_options[i].value) {
                checkSubject = true;
              }
            }
            if (!checkBody) {
              this.fail('emailbody');
              return false;
            }
            if (!checkSubject) {
              this.fail('emailsubject');
              return false;
            }
          case 'overdue_messages':
            if (!self.assignments.settings.due_date || !self.assignments.settings.use_due) {
              this.fail('overdue_messages');
              return false;
            }
          default:
            break;
        }
        return this.fieldCheck(fields);
      },
      create: function() {
        var user = Authorization.getAuthToken().user;
        self.workflow.user = user._id;
        self.workflow.enabled = false;
        if (!this.stepCheck('title')) {
          return;
        }
        if (self.assignments.settings.overdue_messages?.length && !this.stepCheck('overdue_messages')) {
          return;
        }

        var settings = Object.assign({}, self.assignments.settings);
        if (settings.due_date && settings.use_due) {
          settings.days_to_complete = settings.due_date;
        }
        if (!settings.due_date || !settings.use_due) {
          settings.days_to_complete = 0;
        }
        delete settings.due_date;
        delete settings.use_due;
        self.workflow = Object.assign(self.workflow, settings);

        self.waiting = true;
        Workflows.create(self.workflow).$promise.then(function() {
          self.editSaved = true;
          self.waiting = false;
          Application.messaging.addMessage({type: 'success', text: self.translations['editWorkflow.workflow_created'], duration: 7});
          Application.navigation.goTo('/overview/workflows');
        }).catch(function(error) {
          self.waiting = false;
          if (error && error.data.errors) {
            Application.messaging.renderApiResponseErrorCodes(error.data, {
              REQUIRE_RECOMPLETION_TYPE_DISALLOWED: self.translations["assignment.errors.create.REQUIRE_RECOMPLETION_TYPE_DISALLOWED"],
              OVERDUE_MESSAGE_MISSING_CADENCE: self.translations["assignment.errors.create.OVERDUE_MESSAGE_MISSING_CADENCE"]
            });
          } else {
            Application.messaging.addMessage({
              type: 'error',
              text: self.translations['editWorkflow.workflow_not_created'],
              duration: 7
            });
          }
        });
      },
      update: function() {
        if (!this.stepCheck('title')) {
          return;
        }
        if (self.assignments.settings.overdue_messages?.length &&  !this.stepCheck('overdue_messages')) {
          return;
        }

        var settings = Object.assign({}, self.assignments.settings);
        if (settings.due_date && settings.use_due) {
          settings.days_to_complete = settings.due_date;
        }
        if (!settings.due_date || !settings.use_due) {
          settings.days_to_complete = 0;
        }
        delete settings.due_date;
        delete settings.use_due;
        self.workflow = Object.assign(self.workflow, settings);
        self.waiting = true;
        Workflows.update({
          subresource: self.workflow._id,
          fields: 'user,type,name,enabled,object_type,object_instance,object_number,conditionals,response_options,responses,non_reminder_messages,reminder_messages,overdue_messages,days_to_complete,escalation_contacts,days_to_complete,escalation_contacts,escalate_manager,escalate_buddy,due_from_hired,due_days_after_hired,partner_permissions'
        }, self.workflow).$promise
            .then(function(workflow) {
              self.editSaved = true;
              self.workflow = workflow;
              self.parseAll();
              self.waiting = false;
              Application.messaging.addMessage({type: 'success', text: self.translations['editWorkflow.workflow_updated'], duration: 7});
            }).catch(function(error) {
              self.waiting = false;
              if (error && error.data.errors) {
                Application.messaging.renderApiResponseErrorCodes(error.data, {
                  REQUIRE_RECOMPLETION_TYPE_DISALLOWED: self.translations["assignment.errors.create.REQUIRE_RECOMPLETION_TYPE_DISALLOWED"],
                  OVERDUE_MESSAGE_MISSING_CADENCE: self.translations["assignment.errors.create.OVERDUE_MESSAGE_MISSING_CADENCE"]
                });
              } else {
                Application.messaging.addMessage({
                  type: 'error',
                  text: self.translations['editWorkflow.workflow_not_updated'],
                  duration: 7
                });
              }
        });
      },
      delete: function() {
        self.waiting = true;
        Workflows.remove({subresource: self.workflow._id}).$promise
            .then(function(success) {
              self.editSaved = true;
              this.showDelete = false;
              self.waiting = true;
              Application.messaging.addMessage({type: 'success', text: self.translations['editWorkflow.workflow_deleted'], duration: 7});
              Application.navigation.goTo('/overview/workflows');
            }).catch(function(error) {
          self.waiting = false;
          Application.messaging.addMessage({type: 'error', text: self.translations['editWorkflow.workflow_not_deleted'], duration: 7});
        });
      }
    };

    self.navigation = {
      options: ['if', 'and', 'then', 'title', 'notifications'],
      showNext: true,
      next: function() {
        var index = this.options.indexOf(self.activetab);
        if (index !== -1 && this.options[index + 1]) {
          this.move(this.options[index + 1]);
        }
      },
      move: function(location) {
        if (location === self.activetab) {
          return;
        }

        if (location === 'if') {
          self.activetab = this.options[0];
          this.showNext = true;
          return;
        }

        for (var i = 0; i < this.options.length; i++) {
          if (!self.validation.stepCheck.call(self.validation, this.options[i])) {
            self.activetab = this.options[i];
            this.showNext = true;
            if (i + 1 === this.options.length) {
              this.showNext = false;
            }
            return;
          }
          if (location === this.options[i + 1]) {
            self.activetab = this.options[i + 1];
            this.showNext = true;
            if (i + 2 === this.options.length) {
              this.showNext = false;
            }
            return;
          }
        }
      }
    };

    self.observe = {
      initial: null,
      clear: false,
      update: function(items) {
        if (!items || !items.length) {
          delete self.workflow.object_type;
          delete self.workflow.object_instance;
          return;
        }
        self.workflow.object_type = items[0].type;
        self.workflow.object_instance = items[0]._id;
      },
      changed: function() {
        if (!self.workflow) {
          return;
        }
        if (self.workflow.type !== 'completed_content' && self.workflow.type !== 'completed_assignment') {
          self.workflow.object_type = 'user';
          delete self.workflow.object_instance;
          this.clear = true;
        }
      },
      parse: function() {
        if (!self.workflow || (self.workflow.type !== 'completed_content' && self.workflow.type !== 'completed_assignment' && self.workflow.type !== 'attended_workshop' && self.workflow.type !== 'registered_workshop') || !self.workflow.object_type || !self.workflow.object_instance) {
          return;
        }
        this.initial = [{
            type: self.workflow.object_type,
            id: self.workflow.object_instance,
            number: self.workflow.object_number
          }];
      }
    };


    var conditionalListOptions = ['location', 'department', 'team', 'org_level', 'grade', 'group', 'location_added', 'department_added', 'team_added', 'org_level_added', 'grade_added', 'group_added', 'group_location', 'group_department', 'group_team', 'group_org_level', 'group_grade', 'hired_within-custom-days', 'hired_exactly-custom-days-ago'];
    var conditionalBooleanOptions = ['all_teams', 'all_groups', 'all_teams_added', 'all_groups_added', 'hired_within-30-days', 'users_and_groups', 'groups_fields_all'];

    self.condition = {
      parse: function() {
        var items = {};

        // var hired_exactly_custom_days_ago = [];
        if (!self.workflow || !self.workflow.conditionals || !self.workflow.conditionals.length) {
          return;
        }
        for (var i = 0; i < self.workflow.conditionals.length; i++) {
          var item = {
            type: self.workflow.conditionals[i].object_type,
            id: self.workflow.conditionals[i].object_instance || self.workflow.conditionals[i]._id,
            number: self.workflow.conditionals[i].object_number || null
          };

          if (conditionalListOptions.indexOf(item.type) !== -1) {
            this[item.type + 'Visible'] = true;
            if (!items[item.type]) {
              items[item.type] = [];
            }
            items[item.type].push(item);
            if (item.type.indexOf('group_') !== -1 && item.type !== 'group_added') {
              self.showAdvanced = true;
            }
          }

          if (conditionalBooleanOptions.indexOf(item.type) !== -1) {
            this[item.type] = true;
          }

          this[item.type + 'Number'] = item.number;
        }

        conditionalListOptions.forEach(function(type) {
          self.condition[type] = items[type] || [];
        });
      },
      listItemUpdate: function(items, type, number) {
        var matchType = type;
        if (type.indexOf('group_') !== -1 && type !== 'group_added') {
          matchType = type.substr(6);
        }
        if (type.indexOf('_added') !== -1) {
          matchType = type.substring(0, type.length - 6);
        }
        var conditions = [];
        if (number || number === 0) {
          conditions.object_number = number;
          conditions.push({
            object_type: type,
            object_number: number
          });
        } else {
          for (var i = 0; i < items.length; i++) {
            if (items[i]._id && items[i].type && items[i].type === matchType) {
              conditions.push({
                object_type: type,
                object_instance: items[i]._id
              });
            }
          }
        }

        this.combine(conditions, type);
      },
      booleanItemUpdate: function(type) {
        var remove = true;
        if (this[type]) {
          remove = false;
        }
        if (!self.workflow.conditionals) {
          self.workflow.conditionals = [];
        }
        for (var i = 0; i < self.workflow.conditionals.length; i++) {
          if (self.workflow.conditionals[i].object_type === type) {
            self.workflow.conditionals.splice(i, 1);
          }
        }
        if (!remove) {
          if (!self.workflow.conditionals) {
            self.workflow.conditionals = [];
          }
          self.workflow.conditionals.push({object_type: type});
        }
      },
      combine: function(items, type) {
        if (!items || !type || !self.workflow) {
          return;
        }
        if (!self.workflow.conditionals) {
          self.workflow.conditionals = [];
        }
        for (var i = self.workflow.conditionals.length - 1; i >= 0; i--) {
          if (self.workflow.conditionals[i].object_type === type) {
            self.workflow.conditionals.splice(i, 1);
          }
        }
        self.workflow.conditionals = self.workflow.conditionals.concat(items);
      },
      toggle: function(type) {

        if (conditionalListOptions.indexOf(type) !== -1) {
          if (!this[type + 'Visible']) {
            this.combine([], type);
            this[type + 'Clear'] = true;
          }
        }
      }
    };

    conditionalListOptions.forEach(function(item) {
      self.condition[item] = null;
      self.condition[item + 'Visible'] = false;
      self.condition[item + 'Clear'] = false;
      self.condition[item + 'Number'] = null;
    });

    conditionalBooleanOptions.forEach(function(item) {
      self.condition[item] = false;
    })

    self.response = {
      assignments: null,
      assignmentsClear: false,
      assignmentsVisible: false,
      assignmentsDelayNumberOfDays: 0,
      shares: null,
      sharesClear: false,
      sharesVisible: false,
      parse: function() {
        var shares = [];
        var assignments = [];
        if (!self.workflow || !self.workflow.responses || !self.workflow.responses.length) {
          return;
        }
        for (var i = 0; i < self.workflow.responses.length; i++) {
          var item = self.workflow.responses[i];
          if (item.type === 'assignment') {
            this.assignmentsVisible = true;
            assignments.push({
              type: item.object_type,
              id: item.object_instance
            });
          }
          if (item.type === 'share') {
            this.sharesVisible = true;
            shares.push({
              type: item.object_type,
              id: item.object_instance
            });
          }
        }
        if (self.workflow.response_options) {
          for (var i = 0; i < self.workflow.response_options.length; i++) {
            if (self.workflow.response_options[i].name === 'delay-all-responses-in-days') {
              this.assignmentsDelayNumberOfDays = parseInt(self.workflow.response_options[i].value);
            }
          }
        }
        this.assignments = assignments;
        this.shares = shares;
      },
      assignmentsDelayUpdate: function() {
        if (self.workflow.response_options) {
          var delayed_option_found = false;
          for (var i = 0; i < self.workflow.response_options.length; i++) {
            if (self.workflow.response_options[i].name === 'delay-all-responses-in-days') {
              self.workflow.response_options[i].value = parseInt(this.assignmentsDelayNumberOfDays);
              delayed_option_found = true;
            }
          }
          if (!delayed_option_found) {
            self.workflow.response_options.push({name: 'delay-all-responses-in-days', value: parseInt(this.assignmentsDelayNumberOfDays)});
          }
        } else {
          if (parseInt(this.assignmentsDelayNumberOfDays) > 0) {
            self.workflow.response_options = [];
            self.workflow.response_options.push({name: 'delay-all-responses-in-days', value: parseInt(this.assignmentsDelayNumberOfDays)});
          }
        }
      },
      assignmentsUpdate: function(items) {
        var responses = [];
        for (var i = 0; i < items.length; i++) {
          if (items[i]._id && items[i].type) {
            responses.push({
              type: 'assignment',
              object_type: items[i].type,
              object_instance: items[i]._id
            });
          }
        }
        this.combine(responses, 'assignment');
      },
      sharesUpdate: function(items) {
        var responses = [];
        for (var i = 0; i < items.length; i++) {
          if (items[i]._id && items[i].type) {
            responses.push({
              type: 'share',
              object_type: items[i].type,
              object_instance: items[i]._id
            });
          }
        }
        this.combine(responses, 'share');
      },
      combine: function(items, type) {
        if (!items || !type || !self.workflow) {
          return;
        }
        if (!self.workflow.responses) {
          self.workflow.responses = [];
        }
        for (var i = self.workflow.responses.length - 1; i >= 0; i--) {
          if (self.workflow.responses[i].type === type) {
            self.workflow.responses.splice(i, 1);
          }
        }
        self.workflow.responses = self.workflow.responses.concat(items);
        self.workflow.responses.forEach(function(item) {
          if (item.type === 'assignment') {
            self.hasAssignment = true;
          }
        });
      },
      toggle: function(type) {
        if (type === 'assignment') {
          if (!this.assignmentsVisible) {
            this.combine([], 'assignment');
            this.assignmentsClear = true;
          }
        }
        if (type === 'share') {
          if (!this.sharesVisible) {
            this.combine([], 'share');
            this.sharesClear = true;
          }
        }
      }
    };

    self.assignments = {
      settings: {
        escalation_contacts: [],
        non_reminder_messages: [],
        reminder_messages: [],
        overdue_messages: [],
        due_date: 30,
        use_due: false,
        due_from_hired: false,
        due_days_after_hired: 30
      },
      addMessage: function(message) {
        const messageType = message.type.indexOf('reminder') !== -1 ? 'rm' : message.type.indexOf('overdue') !== -1 ? 'om' : 'nrm';
        const nrmPlace = self.assignments.settings.non_reminder_messages.indexOf(message._id);
        let rmPlace = -1;
        let omPlace = -1;
        for (var i = 0; i < self.assignments.settings.reminder_messages.length; i++) {
          if (self.assignments.settings.reminder_messages[i].message === message._id) {
            rmPlace = i;
            break;
          }
        }
        for (const [i, om] of self.assignments.settings.overdue_messages.entries()) {
          if (om.message === message._id) {
            omPlace = i;
            break;
          }
        }

        if (messageType === 'nrm') {
          if (nrmPlace === -1) {
            self.assignments.settings.non_reminder_messages.push(message._id);
          }
          if (rmPlace !== -1) {
            self.assignments.settings.reminder_messages.splice(rmPlace, 1);
          }
        }

        if (messageType === 'rm') {
          if (rmPlace === -1) {
            self.assignments.settings.reminder_messages.push({
              message: message._id,
              time_before_due: message.time_before_due
            });
          } else {
            self.assignments.settings.reminder_messages[rmPlace] = {
              message: message._id,
              time_before_due: message.time_before_due
            }
          }

          if (nrmPlace !== -1) {
            self.assignments.settings.non_reminder_messages.splice(nrmPlace, 1);
          }
        }

        if (messageType === 'om') {
          const overdueMessage = {
            message: message._id,
            cadence: message.cadence,
            total_messages: message.total_messages,
          };
          if (omPlace === -1) {
            self.assignments.settings.overdue_messages.push(overdueMessage);
          } else {
            self.assignments.settings.overdue_messages[omPlace] = overdueMessage;
          }
          if (rmPlace !== -1) {
            self.assignments.settings.reminder_messages.splice(rmPlace, 1);
          }
          if (nrmPlace !== -1) {
            self.assignments.settings.non_reminder_messages.splice(nrmPlace, 1);
          }
        }

        if (self.workflow._id) {
          self.validation.update();
        }
      }
    }

    self.title = {
      from_name: null,
      from_email: null,
      subject: null,
      body: null,
      parse: function() {
        if (!self.workflow.response_options || !self.workflow.response_options.length) {
          return;
        }
        for (var i = 0; i < self.workflow.response_options.length; i++) {
          if (self.workflow.response_options[i].name === 'email-body') {
            var newlinereplaced = self.workflow.response_options[i].value.replace(/<br\/>/g, '\n');
            self.title.body = newlinereplaced;
          }
          if (self.workflow.response_options[i].name === 'email-from-name') {
            self.title.from_name = self.workflow.response_options[i].value;
          }
          if (self.workflow.response_options[i].name === 'email-from-email') {
            self.title.from_email = self.workflow.response_options[i].value;
          }
          if (self.workflow.response_options[i].name === 'email-subject') {
            self.title.subject = self.workflow.response_options[i].value;
          }
        }
      },
      update: function(type) {
        if (!self.workflow.response_options || !self.workflow.response_options.length) {
          self.workflow.response_options = [];
        }
        if (self.workflow.response_options.length <= 1) {
          self.workflow.response_options.push({name: 'email-body', value: this.body || ''});
          self.workflow.response_options.push({name: 'email-from-name', value: this.from_name || 'Continu'});
          self.workflow.response_options.push({name: 'email-from-email', value: this.from_email || 'noreply@continu.co'});
          self.workflow.response_options.push({name: 'email-subject', value: this.subject || ''});
        }
        if (type === 'body') {
          for (var i = 0; i < self.workflow.response_options.length; i++) {
            if (self.workflow.response_options[i].name === 'email-body' && self.title.body) {
              self.workflow.response_options[i].value = self.title.body.replace(/(?:\r\n|\r|\n)/g, '<br/>');
              break;
            }
          }
        }
        if (type === 'from_name') {
          for (var i = 0; i < self.workflow.response_options.length; i++) {
            if (self.workflow.response_options[i].name === 'email-from-name' && self.title.from_name) {
              self.workflow.response_options[i].value = self.title.from_name;
              break;
            }
          }
        }
        if (type === 'from_email') {
          for (var i = 0; i < self.workflow.response_options.length; i++) {
            if (self.workflow.response_options[i].name === 'email-from-email' && self.title.from_email) {
              self.workflow.response_options[i].value = self.title.from_email;
              break;
            }
          }
        }
        if (type === 'subject') {
          for (var i = 0; i < self.workflow.response_options.length; i++) {
            if (self.workflow.response_options[i].name === 'email-subject' && self.title.subject) {
              self.workflow.response_options[i].value = self.title.subject;
              break;
            }
          }
        }
      }
    };
  
   self.partners = {
    partnerPermission: 'tenant',
    changePermission: (permission) => {
      self.partners.partnerPermission = permission;
    }
  }

    self.initialize = function() {
      if (self.user.role !== 'admin' && self.user.role !== 'creator') {
        Application.navigation.goTo('/explore');
        return;
      }

      if (self.newFlow) {
        self.workflow = {};

        $scope.$watch('workflow.workflow.type', function(newVal, oldVal) {
          if (newVal !== 'completed_content' && oldVal === 'completed_content') {
            self.observe.changed();
          }
        });
        self.startEditWatch();
        return;
      }

      Workflows.get({
        subresource: routeParameters.id,
        fields: 'user,type,name,enabled,object_type,object_instance,object_number,conditionals,response_options,responses,non_reminder_messages,reminder_messages,overdue_messages,days_to_complete,escalation_contacts,escalate_manager,escalate_buddy,due_from_hired,due_days_after_hired,require_recompletion,partner_permissions'
      }).$promise.then(function(data) {
        self.workflow = data;
        self.parseAll();
        self.startEditWatch();

        self.workflow.responses.forEach(function(item) {
          if (item.type === 'assignment') {
            self.hasAssignment = true;
          }
        });

        if (self.workflow.partner_permissions) {
          self.partners.partnerPermission = self.workflow.partner_permissions;
        }

        // account for showing the original email
        if (self.hasAssignment && (!self.workflow.non_reminder_messages || !self.workflow.non_reminder_messages.length)) {
          self.dynamicOrOriginal = true;
          self.messageTab = 'original';
        }

        self.assignments.settings = {
          non_reminder_messages: data.non_reminder_messages,
          reminder_messages: data.reminder_messages,
          overdue_messages: data.overdue_messages,
          due_date: data.days_to_complete,
          due_from_hired: data.due_from_hired,
          due_days_after_hired: data.due_days_after_hired,
          escalation_contacts: data.escalation_contacts,
          escalate_manager: data.escalate_manager,
          escalate_buddy: data.escalate_buddy,
          require_recompletion: data.require_recompletion,
        }
        if (self.workflow.days_to_complete) {
          self.assignments.settings.use_due = true;
        }

        $scope.$watch('workflow.workflow.type', function(newVal, oldVal) {
          if (newVal !== 'completed_content' && oldVal === 'completed_content') {
            self.observe.changed();
          }
        });

      });
    };
    
    self.parseAll = function() {
      self.response.parse();
      self.observe.parse();
      self.condition.parse();
      self.title.parse();
    };
    
    self.startEditWatch = function() {
      $scope.$watch('workflow.workflow', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.editSaved = false;
      }, true);
    };
    
    
    $scope.$watch('workflow.partners.partnerPermission', function (newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.workflow.partner_permissions = newVal;
    }, true);
  
    self.decreaseDay = function(){
      self.response.assignmentsDelayNumberOfDays = self.response.assignmentsDelayNumberOfDays - 1;
    };

    self.increaseDay = function(){
      self.response.assignmentsDelayNumberOfDays = self.response.assignmentsDelayNumberOfDays + 1;
    };

    $translate([
      'edit.workflows.errors_type',
      'edit.workflows.errors_object_type',
      'edit.workflows.errors_object_instance',
      'edit.workflows.errors_object_number',
      'edit.workflows.errors_conditional_object_type',
      'edit.workflows.errors_addLocation',
      'edit.workflows.errors_addDepartment',
      'edit.workflows.errors_addTeam',
      'edit.workflows.errors_addOrgLevel',
      'edit.workflows.errors_addGrade',
      'edit.workflows.errors_addConditionalCustomDays',
      'edit.workflows.errors_noresponse',
      'edit.workflows.errors_responseitem',
      'edit.workflows.errors_name',
      'edit.workflows.errors_noemail',
      'edit.workflows.errors_emailsubject',
      'edit.workflows.errors_emailbody',
      'editWorkflow.workflow_created',
      'editWorkflow.workflow_not_created',
      'editWorkflow.workflow_updated',
      'editWorkflow.workflow_not_updated',
      'editWorkflow.workflow_deleted',
      'editWorkflow.workflow_not_deleted',
      'assignContent.overdue_due_date',
      'assignment.errors.create.REQUIRE_RECOMPLETION_TYPE_DISALLOWED',
      'assignment.errors.create.OVERDUE_MESSAGE_MISSING_CADENCE',
    ]).then(function(translations) {
      self.translations = translations;
      self.initialize();
    });

  }]);
